import { Op } from '@unifyapps/network/generated/models/op';

export const getPlatformInterfaceNamespaceFilter = (lng: string, ns: string) => ({
  filter: {
    op: Op.AND,
    values: [
      {
        field: 'properties.interfaceId',
        op: Op.EQUAL,
        values: ['ua-platform'],
      },
      {
        field: 'properties.locale',
        op: Op.EQUAL,
        values: [lng],
      },
      {
        field: 'properties.interfaceComponentId',
        op: Op.IN,
        values: [`__ua_${ns}`],
      },
    ],
  },
  // Ideally, for given interfaceId, locale and interfaceComponentId, there should be only one record
  page: { limit: 100, offset: 0 },
});

// These are the namespace's currently supported via e_i18n_namespace i18n method.
// Maintaining this list because we don't want to try fetching e_i18n_namespace for unsupported ns's, as this call will be blocking on server
const SUPPORTED_PLATFORM_INTERFACE_NS = new Set(['ai-agents']);
const EMPTY_ARRAY = [];
export const getPlatformInterfaceNsArray = (ns: string | string[] | undefined) => {
  if (!ns) {
    return EMPTY_ARRAY;
  }

  const nsArray = (Array.isArray(ns) ? ns : [ns]).filter(Boolean);
  return nsArray.filter((item) => SUPPORTED_PLATFORM_INTERFACE_NS.has(item));
};
